import React from "react";
import cn from "classnames";
import { useSelector } from "react-redux";
import DateDiff from "components/DateDiff";

import "./style.css";
import SuccessCheck from "animations/SuccessCheck";
import { CircularProgress } from "@material-ui/core";
import useDebug from "../../../debug";
import Icon from "components/Icon";
import IconButton from "components/IconButton";
//import PropTypes from 'prop-types';

function StatusImage({ status, size }) {
    return (
        <div
            className={cn("notification-status-img", `notification-${status}`)}
        >
            {status === "success" && <SuccessCheck size={"40px"} />}
            {status === "pending" && (
                <div className={"status-image-progress"}>
                    <CircularProgress size={"23px"} />
                </div>
            )}
            {status === "fail" && (
                <div className={"notification-status-icon"}>
                    <Icon>mui-error</Icon>
                </div>
            )}
        </div>
    );
}

function Notification(props) {
    const { message, status, created_at, log } = props;
    const title = Object.values(log)[0]?.name;
    const logContent = Object.values(log)
        .filter((l) => !!l.log)
        .map((l) => l.log)
        .join("\n");
    const onDebug = useDebug();
    return (
        <div className={"notification"}>
            <StatusImage status={status} size={"40px"} />
            <div className={"notification-content"}>
                <div className={"notification-time"}>
                    <DateDiff value={created_at} />
                </div>
                <div>
                    {title && (
                        <div className={"notification-title"}>{title}</div>
                    )}
                    {Object.values(log).map((item, index) => {
                        return (
                            <div key={item.task_id}>
                                <div>{item.message}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
            {logContent && (
                <IconButton
                    onClick={() => onDebug("code://" + logContent)}
                    icon={"mui-open_in_new"}
                />
            )}
        </div>
    );
}

Notification.defaultProps = {
    log: {},
};

export function NotificationsList(props) {
    const {} = props;
    const notifications =
        useSelector((state) => {
            return state.notifications.notifications;
        }) || {};
    const list = Object.values(notifications).reverse();
    const last = list[0] || null;

    if (!last) {
        return <div>Nothing new</div>;
    }
    return (
        <div className={"overflow-scroll rows gap-sm pad-md"}>
            {list.map((n) => (
                <Notification key={n.id} {...n} />
            ))}
            {/*<pre>{JSON.stringify(last, null, 2)}</pre>*/}
        </div>
    );
}

NotificationsList.propTypes = {};

NotificationsList.defaultProps = {};

export default NotificationsList;
